export default __webpack_public_path__ + "heroImage.d3bdaa5c2575f2fce88eefcc3179d382.png";